export default __webpack_public_path__ + "static/media/javascript.2a6706e9.svg";